/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PhotoStatus = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
export type PdpSharedDealerDetailsHeader_seller = {
    readonly isRewardsTier2: boolean | null;
    readonly monthsSinceStartDate: number | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly shippingAddress: {
        readonly displayFullCityStateCountry: string | null;
    } | null;
    readonly liveStorefrontProfile: {
        readonly headshots: ReadonlyArray<{
            readonly status: PhotoStatus | null;
            readonly path: string | null;
        } | null> | null;
        readonly galleryAlbum: {
            readonly mediaList: ReadonlyArray<{
                readonly element: {
                    readonly path?: string | null;
                    readonly url?: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStarRating_seller" | "PdpSharedDealerDetailsFeedback_seller" | "PdpSharedDealerDetailsBioModalLazy_seller">;
    readonly " $refType": "PdpSharedDealerDetailsHeader_seller";
};
export type PdpSharedDealerDetailsHeader_seller$data = PdpSharedDealerDetailsHeader_seller;
export type PdpSharedDealerDetailsHeader_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsHeader_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsHeader_seller">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsHeader_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isRewardsTier2",
      "name": "isAnchorListMember",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "kind": "ScalarField",
      "alias": "monthsSinceStartDate",
      "name": "timeSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shippingAddress",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "displayFullCityStateCountry",
          "name": "displayCityStateCountry",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "liveStorefrontProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "headshots",
          "name": "photos",
          "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")",
          "args": [
            {
              "kind": "Literal",
              "name": "photoType",
              "value": "DEALER_STOREFRONT_HEADSHOT"
            }
          ],
          "concreteType": "Photo",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "galleryAlbum",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaAlbum",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaList",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaElement",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "element",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "type": "Photo",
                      "selections": [
                        (v0/*: any*/)
                      ]
                    },
                    {
                      "kind": "InlineFragment",
                      "type": "Video",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "url",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedStarRating_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsFeedback_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModalLazy_seller",
      "args": null
    }
  ]
};
})();
(node as any).hash = '196358364afd12d1d24f58f1eca8fc41';
export default node;
